import React from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { AQUA_BASE } from '../../../reports-constants.js';
import { useLaunchUrl } from '../../../contexts/LaunchContext.jsx';
import { getAVGScoreColumn } from './componentFunctions';
import s from '../QuantQual.module.css';
import { clickByAssignment } from '../../../../analyticsEvents.js';
import { PERFORMANCE_BY_ASSIGNMENT_TOOLS } from '../../../constants';

import PaginatedTable from '../../../../../components/PaginatedTable/PaginatedTable';

const performanceByAssignmentComponent = ({ data, courseId, onTabChange, reportType, sendEvent }) => {
  const getLaunchUrl = useLaunchUrl();
  const dispatch = useDispatch();

  const handleAssignmentClick = () => {
    dispatch(sendEvent(clickByAssignment(reportType)));
  };

  const filteredAssignments = data.filter(assignment => PERFORMANCE_BY_ASSIGNMENT_TOOLS.includes(assignment.tool));

  const tableStyle = [
    {
      row: 'styledRow',
      cells: [
        { accessor: 'name', color: AQUA_BASE },
        { accessor: 'startedQuestions', alignment: 'right' },
        { accessor: 'averageAchievement', alignment: 'right' },
        { accessor: 'correctOnFirstTry', alignment: 'right' },
      ],
    },
  ];

  const tableColumns = [
    {
      accessor: 'name',
      Header: 'Assignment Title',
      cell: (item) => {
        const dataForGetLaunch = {
          tab: 'reports/type/subunit',
          tool: item.tool,
          activity_id: item.activityId,
          id: item.id,
          course_id: courseId,
        };
        return (
          <div>
            <div><a onClick={handleAssignmentClick} href={getLaunchUrl(dataForGetLaunch)} >{item.name}</a></div>
            <div className={s.dueDate}>Due {moment(item.dueDate).format('MMM D, YYYY [at] h:mm a')}</div>
          </div>
        );
      },
    },
    {
      accessor: 'startedQuestions',
      Header: 'Average # of Questions Started Per Student',
      cell: item => <p>{item.startedQuestions === -1 ? '—' : item.startedQuestions}</p>,
    },
    {
      accessor: 'averageAchievement',
      Header: 'Average Achievement',
      cell: (item) => {
        const text = item.assignmentType === 'proficiency' ? '(proficiency assignment) ' : '(completion assignment) ';
        return (<div className={s.averageAchievement}>
          <p>{text}</p>
          <p>{item.averageAchievement === -1 ? '—' : `${Math.round(item.averageAchievement * 100)}%`}</p>
        </div>);
      },
    },
    {
      accessor: 'correctOnFirstTry',
      Header: 'Questions Correct on First Try',
      cell:
        item => getAVGScoreColumn(item, 'correctOnFirstTry'),
    },
  ];

  const modalContent = (
    <div>
      <p><b>Average # of questions started per student</b> represents the number of questions on this assignment that a student in your class probably began (for some assignments this number is variable by student based on performance which is why it is presented as an average).</p>
      <p><b>Average achievement</b> is the average class score on the assignment. There are two types of achievement score: <br /></p>
      <p className={s.modalOption}><b>Completion assignments</b> are either assigned readings or assessments (such as practice quizzes or homework assignments) where your students were granted multiple attempts on each question to help students build content understanding.<br /></p>
      <p className={s.modalOption}><b>Proficiency assignments</b> are assessments (such as quizzes or tests) where your students were granted only one attempt on each question to measure content proficiency .<br /></p>
      <p><b>Question correct on first try</b> represents, across all questions on this assignment answered by all students in your class, the proportion that were correct on a student&#39;s first try.<br /></p>
    </div>
  );

  const nullStateContent = (
    <p>
      There are no assignments covering this Subunit.<br />
      Go to <button className={s.nullStateButton} role="link" onClick={() => { onTabChange('assignments'); }}>Course Planner</button> tab to setup and manage assignments.
    </p>
  );

  return (
    <div className={s.performanceByAssignment} data-test-id={`${reportType}-performance-by-assignment`}>
      <PaginatedTable
        id="performanceByAssignmentCard"
        className={s.performanceCard}
        title="Performance by Assignment"
        data={filteredAssignments}
        tableStyle={tableStyle}
        tableColumns={tableColumns}
        sortBy={['correctOnFirstTry', 'name']}
        direction="asc"
        modalContent={modalContent}
        nullState={nullStateContent}
        styleFunction={() => 'styledRow'}
        reportType={reportType}
      />
    </div>
  );
};

export default performanceByAssignmentComponent;
